/**
 * Generated by orval v7.1.0 🍺
 * Do not edit manually.
 * Vori API
 * OpenAPI spec version: 1.0.0
 */

export enum FlowValidationGraphErrorDTOType {
  INVALID_EDGE = 'INVALID_EDGE',
  NO_ENTRY_POINT = 'NO_ENTRY_POINT',
  MULTIPLE_ENTRY_POINTS = 'MULTIPLE_ENTRY_POINTS',
  CYCLE_DETECTED = 'CYCLE_DETECTED',
  INVALID_DYNAMIC_INPUT = 'INVALID_DYNAMIC_INPUT',
  SCHEMA_MISMATCH = 'SCHEMA_MISMATCH',
}
